export const elfLetterOccasions = [
  {
    id: "arrival",
    label: "Welcome back / Arrival",
    instruction: "Write a cheerful welcome-back letter from our elf, excited for a new season of Christmas adventures together.",
  },
  {
    id: "forgot-to-move",
    label: "Forgot to move",
    instruction: "Write a gentle, playful letter explaining that our elf stayed in the same spot to rest after a busy night helping Santa. Reassure my child that the magic is still here.",
  },
  {
    id: "goodbye",
    label: "Goodbye",
    instruction: "Write a warm goodbye letter from our elf, thanking my child for the Christmas memories and looking forward to visiting again next year.",
  },
  {
    id: "encouragement",
    label: "Encouragement",
    instruction: "Write an encouraging letter from our elf celebrating my child's effort and kindness, with a gentle reminder that small kind actions make a difference.",
  },
] as const;

export type ElfLetterOccasion = (typeof elfLetterOccasions)[number];
export type ElfLetterOccasionId = ElfLetterOccasion["id"];

export function getElfLetterOccasion(
  id: string | null | undefined,
): ElfLetterOccasion | undefined {
  return elfLetterOccasions.find((occasion) => occasion.id === id);
}

export function elfLetterOccasionFromSearch(search: string): ElfLetterOccasion | undefined {
  return getElfLetterOccasion(new URLSearchParams(search).get("occasion"));
}

/** Guide links carry only an allowlisted occasion, never family details. */
export function elfLetterOccasionUrl(id: ElfLetterOccasionId): string {
  if (!getElfLetterOccasion(id)) return "/elf-letter-generator";
  return `/elf-letter-generator?occasion=${id}`;
}
